import React from "react";
import { FAQ_ITEMS } from "../seo/faqContent.js";
const answer = (q) => FAQ_ITEMS.find((item) => item.q === q).a;
export const CLASS_FAQ_ITEMS = [
  {
    q: "Vem kan registrera klassen?",
    a:
      answer("Vem registrerar gruppen?") +
      " Registreringen är en ansökan som behöver godkännas. Efter godkännande fortsätter onboarding och den vuxna klassansvariga bjuder in eleverna.",
  },
  {
    q: "Behöver eleverna hantera pengar?",
    a:
      answer("Behöver säljarna hantera kontanter?") +
      " Eleverna delar sina personliga säljlänkar och QR-koder. Beställningarna kopplas till rätt säljare och grupp.",
  },
  {
    q: "Hur levereras produkterna?",
    a:
      answer("Hur levereras beställningarna?") +
      " " +
      answer("Hur lång tid tar leveransen?") +
      " Vid gruppleverans tar den klassansvariga emot beställningarna och ansvarar för utdelningen.",
  },
  {
    q: "När betalas pengarna ut?",
    a:
      answer("När betalas förtjänsten ut?") +
      " Klassens gruppledare kan då begära utbetalning. Räkna därför med leverans och väntetid när ni planerar ett gemensamt mål.",
  },
  {
    q: "Kan vi sälja till klassresan och studenten?",
    a: "Samma upplägg kan användas för klassens gemensamma mål, till exempel en klassresa, en avslutning eller gemensamma aktiviteter kring studenten. Klassen väljer sitt mål och en vuxen klassansvarig håller ihop registrering och försäljning. Försäljningen sker via elevernas personliga länkar, och faktisk förtjänst beror på vilka produkter och varianter som säljs.",
  },
];
// Ingen startkostnad utlovas: befintliga FAQ/villkor ger inget sådant besked.
export const CLASS_INTRO = [
  "Klassförsäljning innebär att klassen säljer produkter tillsammans för att samla in pengar till klassresan, klasskassan eller en annan gemensam aktivitet. Med SalesPartner sker försäljningen digitalt. En vuxen klassansvarig registrerar klassen, och eleverna får sedan personliga säljlänkar och QR-koder att dela med dem som vill stötta.",
  "Kunden väljer produkter och beställer online via elevens länk. Eleverna behöver inte hantera kontanter eller ta emot betalningar själva. Varje beställning kopplas till rätt säljare och grupp. Klassen får provision utifrån de produkter och varianter som säljs. Det ger er ett gemensamt upplägg för att sälja saker till klassen, samtidigt som varje elev kan hjälpa till med sin egen länk.",
  React.createElement("a",{href:"/salja-med-klassen",key:"selling-guide"},"Fler idéer: Sälja med klassen"),
];
export const CLASS_STEPS = [
  [
    "user",
    "1. En vuxen registrerar klassen",
    "En vuxen klassansvarig skickar in ansökan och anger grupp samt planerad försäljningsperiod. Registreringen behöver godkännas. Därefter fortsätter onboarding och den klassansvariga bjuder in eleverna. Den vuxna håller ihop upplägget och hjälper klassen att komma igång.",
  ],
  [
    "link",
    "2. Eleverna delar sina länkar",
    "Varje elev får en personlig säljlänk och QR-kod. Länken kan delas med familj och släkt som vill handla och stötta klassen. Kunden ser sortimentet, väljer produkter och beställer online. Beställningen kopplas till eleven och klassen utan att eleven hanterar kontanter.",
  ],
  [
    "cash",
    "3. Klassen får provisionen",
    "Förtjänsten bygger på den faktiska provisionen för sålda produkter och varianter. Efter att alla beställningar har levererats och 14 dagar har passerat kan gruppledaren begära utbetalning. Returer och återbetalningar kan påverka klassens slutliga belopp.",
  ],
];
export const CLASS_PLANNING = [
  "Börja med att prata om vad klassresan ska innebära och vilket gemensamt mål ni vill sätta. Skriv upp målet i kronor och använd kalkylatorn för att räkna baklänges: hur många elever deltar och hur många produkter per elev vill ni planera för? Flytta reglagen tillsammans och jämför olika upplägg. Kom ihåg att 74 kr är ett planeringsvärde, inte en garanterad provision för varje produkt.",
  "Välj sedan en försäljningsperiod och låt en vuxen klassansvarig hålla ihop registrering och onboarding. När klassen är godkänd och eleverna har fått sina länkar kan de dela dem med familj och släkt. Förklara vilket gemensamt mål ni vill samla in pengar till, så blir det lättare att förstå vad köpet stöttar.",
  "Bestäm också hur leveransen ska fungera inom de alternativ som erbjuds: hem till kunden eller gemensamt till klassen. Vid gruppleverans ansvarar den klassansvariga för utdelningen. Planera för att utbetalning kan begäras först när alla beställningar har levererats och 14 dagar har passerat. Returer och återbetalningar kan påverka slutbeloppet. På så sätt knyter ni ihop målet, försäljningen och leveransen innan ni börjar samla pengar till klassresan.",
];
